const astrolabeRequestPayload = require('./astrolabeRequestPayload')

const AUTO_PLAY_INTERVAL_MS = 1000
const NAVIGATION_CONTROL_CLASS = 'featureList-row'
const NAVIGATION_CONTROL_TYPE = 'default'

function createNavigationControls () {
  return [
    {
      label: '后退',
      direction: -1,
      icon: 'el-icon-d-arrow-left',
      className: NAVIGATION_CONTROL_CLASS,
      type: NAVIGATION_CONTROL_TYPE,
      style: { backgroundColor: '#3bb0ff' }
    },
    {
      label: '执行',
      direction: 1,
      icon: 'el-icon-video-play',
      className: NAVIGATION_CONTROL_CLASS,
      type: NAVIGATION_CONTROL_TYPE,
      style: { backgroundColor: 'red' }
    }
  ]
}

function getNavigationControlState (control, activeDirection) {
  const running = activeDirection === control.direction
  return {
    className: control.className,
    type: control.type,
    icon: running ? 'el-icon-video-pause' : control.icon,
    label: running ? '暂停' : control.label,
    style: control.style
  }
}

function resolvePlaybackDirection (activeDirection, requestedDirection) {
  const direction = Number(requestedDirection)
  if (direction !== -1 && direction !== 1) {
    return 0
  }
  return activeDirection === direction ? 0 : direction
}

function toAstronomicalYear (businessYear) {
  return businessYear < 0 ? businessYear + 1 : businessYear
}

function toBusinessYear (astronomicalYear) {
  return astronomicalYear <= 0 ? astronomicalYear - 1 : astronomicalYear
}

function createExactDate (year, month, day, hour, minute, second) {
  const date = new Date(0)
  date.setUTCHours(hour, minute, second, 0)
  // setUTCFullYear avoids Date's special 1900 offset for constructor years 0 through 99.
  date.setUTCFullYear(toAstronomicalYear(year), month - 1, day)
  return date
}

function formatAdjustedDateTime (date) {
  // JavaScript uses astronomical year zero; the UI chronology goes directly from AD 1 to 1 BCE (-1).
  const year = toBusinessYear(date.getUTCFullYear())
  const month = String(date.getUTCMonth() + 1).padStart(2, '0')
  const day = String(date.getUTCDate()).padStart(2, '0')
  const hour = String(date.getUTCHours()).padStart(2, '0')
  const minute = String(date.getUTCMinutes()).padStart(2, '0')
  const second = String(date.getUTCSeconds()).padStart(2, '0')
  return {
    date: `${year}/${month}/${day}`,
    time: `${hour}:${minute}:${second}`
  }
}

function adjustAstrolabeDateTime ({ date, time, amount, unit }) {
  const { year, month, day } = astrolabeRequestPayload.parseDate(date)
  const [hour, minute, second] = String(time || '00:00:00').split(':').map(Number)
  const adjustedDate = createExactDate(year, month, day, hour, minute, second)

  switch (unit) {
    case 'year':
      adjustedDate.setUTCFullYear(adjustedDate.getUTCFullYear() + amount)
      break
    case 'month':
      adjustedDate.setUTCMonth(adjustedDate.getUTCMonth() + amount)
      break
    case 'day':
      adjustedDate.setUTCDate(adjustedDate.getUTCDate() + amount)
      break
    case 'hour':
      adjustedDate.setUTCHours(adjustedDate.getUTCHours() + amount)
      break
    case 'minute':
      adjustedDate.setUTCMinutes(adjustedDate.getUTCMinutes() + amount)
      break
    case 'second':
      adjustedDate.setUTCSeconds(adjustedDate.getUTCSeconds() + amount)
      break
  }

  return formatAdjustedDateTime(adjustedDate)
}

async function runSerialPlayback ({ direction, interval = AUTO_PLAY_INTERVAL_MS, shouldContinue, step, wait }) {
  while (shouldContinue(direction)) {
    await step(direction)
    if (!shouldContinue(direction)) {
      break
    }
    const shouldResume = await wait(interval)
    if (shouldResume === false) {
      break
    }
  }
}

module.exports = {
  AUTO_PLAY_INTERVAL_MS,
  adjustAstrolabeDateTime,
  createNavigationControls,
  getNavigationControlState,
  resolvePlaybackDirection,
  runSerialPlayback
}
